class CurrencyFormatter {
  formatPenceToGBPAmountString = (pence: number): string => {
    return (pence / 100)
      .toLocaleString('en-GB', { style: 'currency', currency: 'GBP' })
      .replace('.00', '')
  }
}

export default new CurrencyFormatter()
